/**
 * 员工管理
 */

import StoreDecorator, {
  Action,
  Mutation,
  Getter,
  AutoLoading
} from '@acgn/herm/lib/store-decorator';

import {
  getTargetStaffList,
  updateStaffTarget,
  setStaffTarget,
  getStaffDetail,
  getDepartUserList,
  getComicStaffList,
  getStaffTargetDetail,
  setUserPrice
} from '../../api/staff';

import {
  getMembers
} from '../../util';

interface StateType {
  targetStaffList?: any; // 员工列表(员工列表使用)
  comicStaffList?: any; // 项目成员
  departStaffList?: any; // 团队成员列表
}
@StoreDecorator
@AutoLoading
class StoreModule {
  public state() {
    return {
      targetStaffList: {},
      comicStaffList: {},
      departStaffList: []
    };
  }

  // 编辑员工目标
  @Action()
  public async updateStaffTarget(state: StateType, payload: any) {
    return await updateStaffTarget(payload);
  }
  // 设定员工目标
  @Action()
  public async setStaffTarget(state: StateType, payload: any) {
    return await setStaffTarget(payload);
  }

  // 获取员工详情
  @Action()
  public async getStaffDetail(state: StateType, payload: any) {
    return await getStaffDetail(payload);
  }

  // 获取员工列表
  @Action('setStaffList')
  public async getTargetStaffList({ commit, state }: any, option: any) {
    return await getTargetStaffList(option);
  }

  // 获取部门成员
  @Action('setDepartUserList')
  public async getDepartUserList(state: StateType, options: any) {
    return await getDepartUserList(options);
  }

  // 获取项目成员
  @Action('setComicStaffList')
  public async getComicStaffList(state: StateType, options: any) {
    return await getComicStaffList(options);
  }

  // 获取项目成员目标详情
  @Action()
  public async getStaffTargetDetail(state: StateType, options: any) {
    return await getStaffTargetDetail(options);
  }

    // 获取项目成员目标详情
    @Action()
    public async setUserPrice(state: StateType, options: any) {
      return await setUserPrice(options);
    }

  // 设置员工列表
  @Mutation('targetStaffList')
  public setStaffList(state: StateType, payload: any) {
    return payload;
  }

  // 设置项目员工列表
  @Mutation('comicStaffList')
  public setComicStaffList(state: StateType, payload: any) {
    return payload.result;
  }

  // 设置部门员工列表
  @Mutation('departStaffList')
  public setDepartUserList(state: StateType, payload: any) {
    return payload.result;
  }

  // 员工列表（设定目标使用）
  @Getter
  public targetStaffList(state: StateType) {
    return state.targetStaffList;
  }

  // 项目成员列表
  @Getter
  public comicStaffList(state: StateType) {
    if (!state.comicStaffList.members) {
      return [];
    }
    const list: any = [];
    state.comicStaffList.members.map((item: any) => {
      list.push({
        id: item.id,
        name: item.name,
        depart: item.position
      });
    });
    return list;
  }

  // 团队成员列表
  @Getter
  public departStaffList(state: StateType) {
    const list = getMembers(state.departStaffList);
    return list;
  }
}
export default new StoreModule();
